'use client';
import { useParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import Layout from '../../Components/Layout/Layout';
import ProductGallery from './components/ProductGallery';
import ProductInfo from './components/ProductInfo';
import ProductDescription from './components/ProductDescription';
import ContactForm from './components/ContactForm';
import ProductReviews from './components/ProductReviews';
import SimilarProducts from './components/SimilarProducts';
import styles from './product.module.css';
import gsap from 'gsap';
import CartTicket from '@/app/Components/Navbar/CartTicket';

// Mock product data - replace with actual data fetching
const productData = {
  zinc: {
    id: 'zinc',
    name: 'ZINC Premium',
    price: '30.00',
    images: [
      'https://longevity20155.sirv.com/zinc/1.webp',
      'https://longevity20155.sirv.com/zinc/2.webp',
      'https://longevity20155.sirv.com/zinc/3.webp',
    ],
    specs: {
      servings: '60',
      dosage: '25mg',
      form: 'Capsules',
      certified: '2024',
    },
    description: 'Welcome to ZINC Premium, where quality meets performance. This premium supplement boasts superior absorption, pharmaceutical-grade ingredients, and third-party testing. Formulated for optimal bioavailability, this product offers essential support for immune function, skin health, and overall wellness.',
  },
  minci: {
    id: 'minci',
    name: 'MINCI Advanced',
    price: '35.00',
    images: [
      'https://longevity20155.sirv.com/minci/1.webp',
      'https://longevity20155.sirv.com/minci/2.webp',
      'https://longevity20155.sirv.com/minci/3.webp',
    ],
    specs: {
      servings: '30',
      dosage: '500mg',
      form: 'Capsules',
      certified: '2024',
    },
    description: 'Experience MINCI Advanced formula, engineered for peak performance. Premium ingredients combined with cutting-edge research deliver exceptional results for metabolism support and energy enhancement.',
  },
  testo: {
    id: 'testo',
    name: 'TESTO Boost',
    price: '40.00',
    images: [
      'https://longevity20155.sirv.com/testo/1.webp',
      'https://longevity20155.sirv.com/testo/2.webp',
      'https://longevity20155.sirv.com/testo/3.webp',
    ],
    specs: {
      servings: '45',
      dosage: '750mg',
      form: 'Capsules',
      certified: '2024',
    },
    description: 'TESTO Boost represents the pinnacle of natural testosterone support. Scientifically formulated with premium ingredients to support vitality, strength, and overall male wellness.',
  },
};

export default function ProductDetail() {
  const params = useParams();
  const product = productData[params.id] || productData.zinc;

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to("#navbar", { autoAlpha: 1 })
      gsap.to("." + styles.container, { transform: "translate3d(0,0,0)", autoAlpha: 1 })
    })
    return () => ctx.revert()
  }, [])



  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.productName}>{product.name}</h1>
          <div className={styles.priceSection}>
            <span className={styles.priceLabel}>Price</span>
            <span className={styles.price}> DT{product.price}</span>
          </div>
        </div>

        <div className={styles.mainContent}>
          <ProductGallery images={product.images} />

          <div className={styles.sidebar}>
            <ProductInfo specs={product.specs} />
            <ContactForm />
          </div>
        </div>

        <ProductDescription description={product.description} />

        <ProductReviews />

        <SimilarProducts currentProductId={product.id} />

      </div>
      <CartTicket />

    </Layout>
  );
}
